import React from "react";
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';

import * as AuthActions from "../../data/auth/AuthActions";

import Dropdown from 'UI/Dropdown';

class Logout extends React.Component
{
    static propTypes = {
        logout: PropTypes.func.isRequired
    };

    state = {
        redirectNow: false
    };

    logoutClick = (event) => {
        event.preventDefault();
        this.props.logout().then(() => {
            this.setState({redirectNow: true});
        });
    };

    render()
    {
        if (this.state.redirectNow) {
            return <Redirect to="/" />;
        }

        return <Dropdown.Item onClick={this.logoutClick}>
            Logout
        </Dropdown.Item>;
    }
}

const mapDispatchToProps = {
    logout: AuthActions.logout,
};

export default connect(null, mapDispatchToProps)(Logout);